import { render, staticRenderFns } from "./devbox.vue?vue&type=template&id=027ffdd9&"
import script from "./devbox.vue?vue&type=script&lang=ts&"
export * from "./devbox.vue?vue&type=script&lang=ts&"
import style0 from "./devbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports